"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetricsPropertyManagement = exports.METRICS_STATUS_OPTIONS = void 0;
var react_1 = require("react");
exports.METRICS_STATUS_OPTIONS = ['In progress', 'Ready'];
var haveSameItems = function (left, right) {
    if (left.length !== right.length) {
        return false;
    }
    return left.every(function (value) { return right.indexOf(value) >= 0; });
};
exports.useMetricsPropertyManagement = function (input) {
    var _a, _b;
    var isOwnerManagementOpen = input.isOwnerManagementOpen, propertyId = input.propertyId, selectedOwnerIds = input.selectedOwnerIds, stagedOwnerIds = input.stagedOwnerIds, stagedStatus = input.stagedStatus, canEditOwner = input.canEditOwner, canEditStatus = input.canEditStatus, shouldShowStatusField = input.shouldShowStatusField, initialStatus = input.initialStatus, onStageManagement = input.onStageManagement;
    var resolvedPersistedOwnerIds = stagedOwnerIds || selectedOwnerIds;
    var resolvedPersistedStatus = stagedStatus || initialStatus;
    var _c = react_1.useState(resolvedPersistedOwnerIds), persistedOwnerIds = _c[0], setPersistedOwnerIds = _c[1];
    var _d = react_1.useState(resolvedPersistedOwnerIds), draftOwnerIds = _d[0], setDraftOwnerIds = _d[1];
    var _e = react_1.useState((_a = {}, _a[propertyId] = resolvedPersistedStatus, _a)), persistedStatusByUseCaseId = _e[0], setPersistedStatusByUseCaseId = _e[1];
    var _f = react_1.useState((_b = {}, _b[propertyId] = resolvedPersistedStatus, _b)), draftStatusByUseCaseId = _f[0], setDraftStatusByUseCaseId = _f[1];
    var _g = react_1.useState(false), isLoadingStatuses = _g[0], setIsLoadingStatuses = _g[1];
    var isSavingManagement = false;
    var managementError = null;
    var hasOwnerChanges = canEditOwner &&
        (!haveSameItems(draftOwnerIds, persistedOwnerIds) ||
            !haveSameItems(persistedOwnerIds, draftOwnerIds));
    var hasStatusChanges = shouldShowStatusField &&
        canEditStatus &&
        (persistedStatusByUseCaseId[propertyId] || exports.METRICS_STATUS_OPTIONS[0]) !==
            (draftStatusByUseCaseId[propertyId] || exports.METRICS_STATUS_OPTIONS[0]);
    var canSaveManagement = hasOwnerChanges || hasStatusChanges;
    react_1.useEffect(function () {
        setPersistedOwnerIds(resolvedPersistedOwnerIds);
        setDraftOwnerIds(resolvedPersistedOwnerIds);
    }, [resolvedPersistedOwnerIds]);
    react_1.useEffect(function () {
        var _a;
        if (!isOwnerManagementOpen || !shouldShowStatusField) {
            return;
        }
        var nextPersisted = (_a = {},
            _a[propertyId] = resolvedPersistedStatus,
            _a);
        setIsLoadingStatuses(false);
        setPersistedStatusByUseCaseId(nextPersisted);
        setDraftStatusByUseCaseId(nextPersisted);
    }, [isOwnerManagementOpen, propertyId, resolvedPersistedStatus, shouldShowStatusField]);
    var handleOwnerSelectionChange = function (ownerId, selected) {
        setDraftOwnerIds(function (current) {
            if (selected) {
                return current.indexOf(ownerId) >= 0 ? current : current.concat(ownerId);
            }
            return current.filter(function (id) { return id !== ownerId; });
        });
    };
    var handleStatusChange = function (useCaseId, status) {
        setDraftStatusByUseCaseId(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[useCaseId] = status, _a)));
        });
    };
    var handleSaveManagement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nextStatus, nextOwnerIds;
        var _a;
        return __generator(this, function (_b) {
            if (!canSaveManagement) {
                return [2 /*return*/];
            }
            nextStatus = draftStatusByUseCaseId[propertyId] || exports.METRICS_STATUS_OPTIONS[0];
            nextOwnerIds = draftOwnerIds.slice();
            setPersistedOwnerIds(nextOwnerIds);
            setPersistedStatusByUseCaseId((_a = {}, _a[propertyId] = nextStatus, _a));
            onStageManagement(propertyId, nextOwnerIds, nextStatus);
            return [2 /*return*/];
        });
    }); };
    var handleCancelManagement = function () {
        setDraftOwnerIds(persistedOwnerIds);
        setDraftStatusByUseCaseId(persistedStatusByUseCaseId);
    };
    return {
        draftOwnerIds: draftOwnerIds,
        draftStatusByUseCaseId: draftStatusByUseCaseId,
        isLoadingStatuses: isLoadingStatuses,
        isSavingManagement: isSavingManagement,
        managementError: managementError,
        canSaveManagement: canSaveManagement,
        handleOwnerSelectionChange: handleOwnerSelectionChange,
        handleStatusChange: handleStatusChange,
        handleSaveManagement: handleSaveManagement,
        handleCancelManagement: handleCancelManagement,
    };
};
